module.exports = __webpack_public_path__ + "05cad00b7c9eb885cef06b03605ddc9e.svg";